export default [
  {
    name: 'Configurações',
    path: 'configuracoes',
    component: () => import('@/views/configuracoes/Index.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [{ name: 'Administração', path: '/administracao' }, { name: 'Configurações' }]
    }
  }
];
